/** Roles that use the Aunak Pro mobile app; web session shows the app landing placeholder. */
export const AUNAK_PRO_APP_ROLES = ['customer', 'solosp', 'cprovider'] as const;

export type AunakProAppRole = (typeof AUNAK_PRO_APP_ROLES)[number];

export function isAunakProAppRole(role: string | undefined | null): boolean {
  if (!role) return false;
  return (AUNAK_PRO_APP_ROLES as readonly string[]).includes(role);
}
